import React from 'react';
import { Outlet, useLocation } from 'react-router-dom';
import { AnimatePresence, motion } from 'framer-motion';
import Header from './Header';
import Footer from './Footer';
import QuantumBackground from '../QuantumBackground';
import WhatsAppButton from '../WhatsAppButton';
import ChatbotWidget from '../ChatbotWidget';

const Layout = () => {
  const location = useLocation();

  return (
    <div className="relative min-h-screen">
      {/* Quantum Background */}
      <QuantumBackground />

      {/* Header */}
      <Header />

      {/* Main Content with Page Transitions */}
      <AnimatePresence mode="wait">
        <motion.main
          key={location.pathname}
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          exit={{ opacity: 0, y: -20 }}
          transition={{ duration: 0.3 }}
        >
          <Outlet />
        </motion.main>
      </AnimatePresence>

      {/* Footer */}
      <Footer />

      {/* Floating Elements */}
      <WhatsAppButton />
      <ChatbotWidget />
    </div>
  );
};

export default Layout;
